import { Http, RequestOptions, Response, URLSearchParams, Headers } from '@angular/http';
import { Component, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/share';

@Injectable()
export class AppUpload {
        /**
         * @param Observable<number>
         */
        private progress$: Observable<number>;

        private progress: number = 0;
        private progressObserver: any;

        constructor () {
            this.progress$ = new Observable(observer => {
                this.progressObserver = observer
            });
        }

        public getObserver (): Observable<number> {
            return this.progress$;
        }

        /**
         * Upload files through XMLHttpRequest
         *
         * @param url
         * @param files
         * @returns {Promise<T>}
         */
        public upload(url: string, files: File[], token?): Promise<any> {
            return new Promise((resolve, reject) => {
                
                let formData: FormData = new FormData(),
                    xhr: XMLHttpRequest = new XMLHttpRequest();

                for (let i = 0; i < files.length; i++) {
                    formData.append("uploads[]", files[i], files[i].name);
                }

                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            resolve(JSON.parse(xhr.response));
                        } else {
                            reject(xhr.response);
                        }
                    }
                };

                AppUpload.setUploadUpdateInterval(500);

                xhr.upload.onprogress = (event) => {
                    this.progress = Math.round(event.loaded / event.total * 100);
                    if (this.progressObserver)
                        this.progressObserver.next(this.progress);
                };
        
                xhr.open('POST', url, true);
                if (token)
                    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
                xhr.send(formData)
            });
        }

        /**
         * Set interval for frequency with which Observable inside Promise will share data with subscribers.
         *
         * @param interval
         */
        private static setUploadUpdateInterval (interval: number): void {
            setInterval(() => {}, interval);
        }
}




// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/app.upload.ts